import { formFieldLabelByName } from './constants';

export const getParsedCvFormData = (parsedFormData) => {
  return parsedFormData.filter(
    (obj) =>
      obj !== undefined && obj.label !== formFieldLabelByName.cvDoc && obj.label !== formFieldLabelByName.otherDocs
  );
};
